module.exports = __webpack_public_path__ + "static/ing_grey-8b62533b177e9c2bdaf75191b6dbb468.svg";